import { render, staticRenderFns } from "./CampusEdit.vue?vue&type=template&id=2d88be4c&"
import script from "./CampusEdit.vue?vue&type=script&lang=js&"
export * from "./CampusEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports